import { CardHeader } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import { BugsReported, RecentBugs } from "../../../../Constant";

const BugsReportedHeader = () => {
  return (
    <CardHeader>
      <div className="d-flex justify-content-between">
        <div className="flex-grow-1">
          <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>
            {BugsReported}
            <i className="fa fa-circle f-10"> </i>
          </P>
          <H4>{RecentBugs}</H4>
        </div>
      </div>
    </CardHeader>
  );
};

export default BugsReportedHeader;
